import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "asetl" }
const _hoisted_2 = {
  class: "sui-card sui-card--flush asetl__board",
  "data-tour": "admin-settle-list"
}
const _hoisted_3 = { class: "asetl__sticky" }
const _hoisted_4 = {
  class: "asetl__filters",
  "data-tour": "admin-settle-kpis",
  "aria-label": "정산 요청 상태"
}
const _hoisted_5 = { class: "asetl__pending-sum-body" }
const _hoisted_6 = {
  class: "sui-toolbar",
  "data-tour": "admin-settle-toolbar"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "sui-search" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "asetl__error"
}
const _hoisted_11 = {
  key: 1,
  class: "asetl__list-count"
}
const _hoisted_12 = { class: "asetl__scroll" }
const _hoisted_13 = {
  key: 0,
  class: "asetl__table-wrap"
}
const _hoisted_14 = { class: "sui-table asetl__table" }
const _hoisted_15 = { class: "sui-table__strong" }
const _hoisted_16 = { class: "sui-table__sub" }
const _hoisted_17 = { class: "sui-table__strong" }
const _hoisted_18 = { class: "is-num" }
const _hoisted_19 = { class: "is-num sui-table__strong" }
const _hoisted_20 = { class: "sui-table__sub" }
const _hoisted_21 = { class: "sui-table__sub" }
const _hoisted_22 = {
  key: 2,
  class: "sui-badge sui-badge--amber"
}
const _hoisted_23 = { class: "asetl__row-actions" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { colspan: "7" }
const _hoisted_30 = { class: "asetl__lines" }
const _hoisted_31 = { class: "sui-table__sub" }
const _hoisted_32 = { class: "is-num" }
const _hoisted_33 = { class: "is-num" }
const _hoisted_34 = { class: "is-num" }
const _hoisted_35 = { class: "is-num" }
const _hoisted_36 = {
  key: 1,
  class: "sui-empty"
}
const _hoisted_37 = { class: "asetl__reopen-sub" }
const _hoisted_38 = { class: "sui-field" }
const _hoisted_39 = { class: "asetl__panel-actions" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  class: "asetl__logs-dialog",
  "data-tour": "admin-settle-log-panel"
}
const _hoisted_42 = { class: "asetl__logs-head" }
const _hoisted_43 = { class: "asetl__logs-body" }
const _hoisted_44 = {
  key: 0,
  class: "asetl__logs-empty"
}
const _hoisted_45 = {
  key: 1,
  class: "asetl__logs-empty is-error"
}
const _hoisted_46 = {
  key: 2,
  class: "asetl__logs-empty"
}
const _hoisted_47 = {
  key: 3,
  class: "asetl__logs-table"
}
const _hoisted_48 = { class: "sui-table__sub" }
const _hoisted_49 = { class: "is-num" }

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { formatWon } from '@/constants/sellerData'
import {
  downloadAdminSettlementRequestExcel,
  fetchAdminSettlementLogs,
  fetchAdminSettlementRequests,
  markAdminSettlementRequestPaid,
  reopenAdminSettlementRequest,
  type AdminSettlementLog,
  type SettlementRequest,
} from '@/api/mallOrder'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSettlementsPage',
  setup(__props) {

const { notify } = useAdminProducts()

const requests = ref<SettlementRequest[]>([])
const requestedCount = ref(0)
const requestedSum = ref(0)
const loading = ref(false)
const errorMessage = ref('')
const period = ref('')
const status = ref('')
const keyword = ref('')
const busy = ref(false)
const opened = ref(0)

const unsettleOpen = ref(false)
const unsettleReason = ref('')
const unsettleTarget = ref<SettlementRequest | null>(null)

const logsOpen = ref(false)
const logsLoading = ref(false)
const logsError = ref('')
const logs = ref<AdminSettlementLog[]>([])

const periodOptions = computed(() => {
  const set = new Set<string>()
  const now = new Date()
  for (let i = 0; i < 12; i += 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1)
    set.add(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`)
  }
  if (period.value) set.add(period.value)
  return [...set].sort((a, b) => b.localeCompare(a))
})

function formatDateTime(value: string | null | undefined) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(
    date.getDate(),
  ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

function toggleBundle(id: number) {
  opened.value = opened.value === id ? 0 : id
}

function setStatus(next: string) {
  if (status.value === next) return
  status.value = next
  void reload()
}

async function reload() {
  loading.value = true
  errorMessage.value = ''
  try {
    const result = await fetchAdminSettlementRequests({
      period: period.value,
      status: status.value,
      keyword: keyword.value,
    })
    requests.value = result.requests
    requestedCount.value = result.requestedCount
    requestedSum.value = result.requestedSum
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '정산 요청을 불러오지 못했습니다.'
    requests.value = []
  } finally {
    loading.value = false
  }
}

async function onExcel(row: SettlementRequest) {
  try {
    await downloadAdminSettlementRequestExcel(row)
  } catch (error) {
    notify(error instanceof Error ? error.message : '엑셀을 내려받지 못했습니다.')
  }
}

async function onPay(row: SettlementRequest) {
  if (busy.value) return
  const ok = await confirmDialog({
    title: '정산 완료',
    message: '이 정산 신청을 완료로 표시할까요?',
    detail: `${row.storeName}\n${row.title}\n${row.count}건 · 지급액 ${formatWon(row.payout)}원`,
    confirmLabel: '완료',
    tone: 'primary',
  })
  if (!ok) return
  busy.value = true
  try {
    notify(await markAdminSettlementRequestPaid(row.id))
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '처리에 실패했습니다.')
  } finally {
    busy.value = false
  }
}

function openUnsettle(row: SettlementRequest) {
  unsettleTarget.value = row
  unsettleReason.value = ''
  unsettleOpen.value = true
}

function closeUnsettle() {
  if (busy.value) return
  unsettleOpen.value = false
  unsettleTarget.value = null
  unsettleReason.value = ''
}

async function submitUnsettle() {
  const target = unsettleTarget.value
  const reason = unsettleReason.value.trim()
  if (!target || busy.value || reason.length < 5) return
  busy.value = true
  try {
    notify(await reopenAdminSettlementRequest(target.id, reason))
    unsettleOpen.value = false
    unsettleTarget.value = null
    unsettleReason.value = ''
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '처리에 실패했습니다.')
  } finally {
    busy.value = false
  }
}

async function openLogs() {
  logsOpen.value = true
  logsLoading.value = true
  logsError.value = ''
  logs.value = []
  try {
    logs.value = await fetchAdminSettlementLogs({ limit: 100 })
  } catch (error) {
    logsError.value = error instanceof Error ? error.message : '이력을 불러오지 못했습니다.'
  } finally {
    logsLoading.value = false
  }
}

function closeLogs() {
  logsOpen.value = false
}

onMounted(() => {
  void reload()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["asetl__filter", { 'is-active': !status.value }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setStatus('')))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("span", { class: "asetl__filter-label" }, "전체", -1)
          ]))], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["asetl__filter", { 'is-active': status.value === 'PAID' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setStatus('PAID')))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("span", { class: "asetl__filter-label" }, "완료", -1)
          ]))], 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["asetl__filter", { 'is-active': status.value === 'REQUESTED', 'is-alert': requestedCount.value > 0 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setStatus('REQUESTED')))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("span", { class: "asetl__filter-label" }, "신청", -1)
          ]))], 2),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "asetl__filters-spacer" }, null, -1)),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn",
            "data-tour": "admin-settle-logs",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openLogs()))
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-history",
              size: 16
            }),
            _cache[10] || (_cache[10] = _createTextVNode(" 처리 이력 ", -1))
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["asetl__pending-sum", { 'is-alert': requestedSum.value > 0 }])
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-cash-clock",
              size: 16
            }),
            _createElementVNode("span", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("em", null, "신청 지급액", -1)),
              _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(requestedSum.value)) + "원", 1)
            ])
          ], 2)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "asetl__guide" }, " 판매업체가 고른 구매확정 건이 묶음으로 신청됩니다. 내용을 확인한 뒤 정산하고 「완료」를 누르면 그 신청은 끝납니다. ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((period).value = $event)),
            class: "sui-select",
            "aria-label": "요청 연월",
            onChange: reload
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "전체 기간", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(option), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, period.value]
          ]),
          _createElementVNode("label", _hoisted_8, [
            _createVNode(AppIcon, {
              icon: "mdi-magnify",
              size: 17
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((keyword).value = $event)),
              type: "search",
              placeholder: "판매업체 · 신청 이름 · 주문번호",
              onKeyup: _withKeys(reload, ["enter"])
            }, null, 544), [
              [
                _vModelText,
                keyword.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "sui-btn",
            disabled: loading.value,
            onClick: reload
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-magnify",
              size: 16
            }),
            _cache[14] || (_cache[14] = _createTextVNode(" 검색 ", -1))
          ], 8, _hoisted_9)
        ]),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
            ]))
          : _createCommentVNode("", true),
        (requests.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(requests.value.length) + "묶음", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (requests.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "판매업체"),
                    _createElementVNode("th", null, "정산 신청"),
                    _createElementVNode("th", { class: "is-num" }, "건수"),
                    _createElementVNode("th", { class: "is-num" }, "지급액"),
                    _createElementVNode("th", null, "요청일시"),
                    _createElementVNode("th", null, "상태"),
                    _createElementVNode("th")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.id
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(row.storeName), 1),
                          _createElementVNode("span", _hoisted_16, [
                            _createTextVNode(_toDisplayString(row.settleBank) + " " + _toDisplayString(row.settleAccount) + " ", 1),
                            (row.settleHolder)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(row.settleHolder), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(row.title), 1)
                        ]),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(row.count) + "건", 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatWon)(row.payout)) + "원", 1),
                        _createElementVNode("td", null, _toDisplayString(formatDateTime(row.requestedAt)), 1),
                        _createElementVNode("td", null, [
                          (row.kind === 'LEGACY')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sui-badge" }, "이전 정산", -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(formatDateTime(row.paidAt)), 1)
                              ], 64))
                            : (row.status === 'PAID')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sui-badge sui-badge--green" }, "완료", -1)),
                                  _createElementVNode("span", _hoisted_21, [
                                    _createTextVNode(_toDisplayString(formatDateTime(row.paidAt)) + " ", 1),
                                    (row.paidBy)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" · " + _toDisplayString(row.paidBy), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, "신청"))
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "sui-btn sui-btn--sm",
                            onClick: ($event: any) => (toggleBundle(row.id))
                          }, _toDisplayString(opened.value === row.id ? '접기' : '건별 보기'), 9, _hoisted_24),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sui-btn sui-btn--sm",
                            onClick: ($event: any) => (onExcel(row))
                          }, "엑셀", 8, _hoisted_25),
                          (row.kind !== 'LEGACY' && row.status === 'REQUESTED')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "sui-btn sui-btn--sm sui-btn--primary",
                                "data-tour": "admin-settle-pay",
                                disabled: busy.value,
                                onClick: ($event: any) => (onPay(row))
                              }, " 완료 ", 8, _hoisted_26))
                            : (row.kind !== 'LEGACY')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "sui-btn sui-btn--sm",
                                  "data-tour": "admin-settle-reopen",
                                  disabled: busy.value,
                                  onClick: ($event: any) => (openUnsettle(row))
                                }, " 완료 해제 ", 8, _hoisted_27))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      (opened.value === row.id)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                            _createElementVNode("td", _hoisted_29, [
                              _createElementVNode("table", _hoisted_30, [
                                _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "주문번호"),
                                    _createElementVNode("th", { class: "is-num" }, "판매대금"),
                                    _createElementVNode("th", { class: "is-num" }, "수수료"),
                                    _createElementVNode("th", { class: "is-num" }, "배송비"),
                                    _createElementVNode("th", { class: "is-num" }, "지급액")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: item.id
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createTextVNode(_toDisplayString(item.orderCode) + " ", 1),
                                        _createElementVNode("span", _hoisted_31, [
                                          _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                                          (item.optionLabel)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · " + _toDisplayString(item.optionLabel), 1)
                                              ], 64))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" · " + _toDisplayString(item.qty) + _toDisplayString(item.unit || '개'), 1)
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(formatWon)(item.salesAmount)) + "원", 1),
                                      _createElementVNode("td", _hoisted_33, "-" + _toDisplayString(_unref(formatWon)(item.platformFee)) + "원", 1),
                                      _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatWon)(item.shippingFee)) + "원", 1),
                                      _createElementVNode("td", _hoisted_35, _toDisplayString(_unref(formatWon)(item.payout)) + "원", 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createVNode(AppIcon, {
                icon: "mdi-cash-off",
                size: 30
              }),
              _createElementVNode("p", null, _toDisplayString(loading.value ? '불러오는 중입니다…' : '정산 신청이 없습니다.'), 1)
            ]))
      ])
    ]),
    (unsettleOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "asetl__modal",
          onClick: _withModifiers(closeUnsettle, ["self"])
        }, [
          _createElementVNode("form", {
            class: "asetl__reopen-dialog",
            onSubmit: _withModifiers(submitUnsettle, ["prevent"])
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", null, "완료 해제", -1)),
            _createElementVNode("p", _hoisted_37, _toDisplayString(unsettleTarget.value?.title) + " 을 다시 신청 상태로 되돌립니다. ", 1),
            _createElementVNode("label", _hoisted_38, [
              _cache[20] || (_cache[20] = _createElementVNode("span", null, [
                _createTextVNode("해제 사유 "),
                _createElementVNode("em", null, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((unsettleReason).value = $event)),
                class: "sui-input",
                rows: "4",
                maxlength: "255",
                placeholder: "예: 송금 오류로 재처리 필요",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  unsettleReason.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeUnsettle
              }, "닫기"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--primary",
                disabled: unsettleReason.value.trim().length < 5 || busy.value
              }, _toDisplayString(busy.value ? '처리 중…' : '완료 해제'), 9, _hoisted_40)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (logsOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "asetl__modal",
          onClick: _withModifiers(closeLogs, ["self"])
        }, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("header", _hoisted_42, [
              _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                _createElementVNode("h3", null, "정산 처리 이력"),
                _createElementVNode("p", null, "최근 처리 전체")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "asetl__close",
                "aria-label": "닫기",
                onClick: closeLogs
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              (logsLoading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_44, "불러오는 중…"))
                : (logsError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(logsError.value), 1))
                  : (!logs.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_46, "이력이 없습니다."))
                    : (_openBlock(), _createElementBlock("table", _hoisted_47, [
                        _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "일시"),
                            _createElementVNode("th", null, "구분"),
                            _createElementVNode("th", null, "처리자"),
                            _createElementVNode("th", null, "주문"),
                            _createElementVNode("th", { class: "is-num" }, "지급액"),
                            _createElementVNode("th", null, "사유")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: log.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(formatDateTime(log.at)), 1),
                              _createElementVNode("td", null, _toDisplayString(log.action === 'UNSETTLE' ? '해제' : '정산'), 1),
                              _createElementVNode("td", null, _toDisplayString(log.actor || '—'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString(log.orderCode), 1),
                                _createElementVNode("span", _hoisted_48, [
                                  _createTextVNode(_toDisplayString(log.storeName) + " ", 1),
                                  (log.productName)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(log.productName), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(formatWon)(log.payout)) + "원", 1),
                              _createElementVNode("td", null, _toDisplayString(log.reason || '—'), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
            ]),
            _createElementVNode("footer", { class: "asetl__panel-actions" }, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "asetl__bulk-spacer" }, null, -1)),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeLogs
              }, "닫기")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})